export const MAP_URL = Object.freeze({
  ROOT: "/",
  /** Pre-swap path — redirected to ROOT so old links keep working. */
  LEGACY_ROOT: "/map",
});
